import * as React from "react";
import type { SVGProps } from "react";
const SvgPaddleLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#3B5BFE" d="M0 0h264v264H0z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M82 48h78c38.66 0 70 31.34 70 70s-31.34 70-70 70h-44v28c0 11.046-8.954 20-20 20s-20-8.954-20-20V48zm34 36h44c18.778 0 34 15.222 34 34s-15.222 34-34 34h-44z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaddleLogoIcon;
